import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5 mb-9" }, null, -1)
const _hoisted_2 = { class: "row mb-7" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Sales Type ", -1)
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, [
  /*#__PURE__*/_createTextVNode(" Schedule "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "ms-3",
    style: {"color":"#900000"}
  }, "( All records will be updated after approve !! )")
], -1)
const _hoisted_7 = { class: "d-flex align-items-center mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-1 me-7",
  for: "daily"
}, "Daily", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-1 me-7",
  for: "month"
}, "Monthly", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "ms-1 me-7",
  for: "pause"
}, "Pause", -1)
const _hoisted_11 = { class: "row mb-5" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Sales Account Uid ", -1)
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Target Account Uid ", -1)
const _hoisted_16 = { class: "row mb-9" }
const _hoisted_17 = { class: "col-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Rebate ", -1)
const _hoisted_19 = { class: "col-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Alpha Rebate ", -1)
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Pro Rebate ", -1)
const _hoisted_23 = { class: "row mb-9" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Exclude Account ", -1)
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Exclude Symbol ", -1)
const _hoisted_28 = { class: "row mb-5" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semobold mb-2 createAccountTitle" }, " Note ", -1)

import { ref, nextTick } from "vue";
import RebateService from "../services/RebateService";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Field } from "vee-validate";
import { salesTypeOptions } from "@/core/types/SalesTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddSalesRebateSchema',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {



const addSalesRebateSchemaShowRef = ref<any>(null);
const schemaInfo = ref({} as any);

const reset = () => {
  schemaInfo.value = {
    salesType: 0,
    salesAccountUid: "",
    rebateAccountUId: "",
    rebate: "",
    alphaRebate: "",
    proRebate: "",
    excludeAccount: "",
    excludeSymbol:
      "#AAPL,#AXP,#BAC,#C,#DIS,#IBM,#INTC,#KO,#MCD,#MSFT,#BA,#QAN.AX,#CSL.AX,#BHP.AX,#6501.T,#6502.T,#7201.T,#7261.T,#8306.T",
    note: "",
  };
};

const show = async () => {
  reset();
  addSalesRebateSchemaShowRef.value?.show();
};

const update = async () => {
  try {
    await RebateService.postSalesRebateSchema(schemaInfo.value);
    emits("refresh");
    addSalesRebateSchemaShowRef.value?.hide();
  } catch (e) {
    MsgPrompt.error(e);
  }
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "addSalesRebateSchemaShowRef",
    ref: addSalesRebateSchemaShowRef,
    title: 'New Schema',
    "is-loading": false,
    width: 800,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_el_select, {
                modelValue: schemaInfo.value.salesType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schemaInfo.value.salesType) = $event)),
                placeholder: _ctx.$t('fields.status')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesTypeOptions), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  id: "daily",
                  type: "radio",
                  value: "0",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schemaInfo.value.schedule) = $event))
                }, null, 512), [
                  [_vModelRadio, schemaInfo.value.schedule]
                ]),
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  id: "month",
                  type: "radio",
                  value: "3",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schemaInfo.value.schedule) = $event))
                }, null, 512), [
                  [_vModelRadio, schemaInfo.value.schedule]
                ]),
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  id: "pause",
                  type: "radio",
                  value: "1",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schemaInfo.value.schedule) = $event))
                }, null, 512), [
                  [_vModelRadio, schemaInfo.value.schedule]
                ]),
                _hoisted_10
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.salesAccountUid,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schemaInfo.value.salesAccountUid) = $event)),
                class: "form-control form-control-lg form-control-solid",
                type: "number",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.salesAccountUid,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schemaInfo.value.salesAccountUid) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.rebateAccountUId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((schemaInfo.value.rebateAccountUId) = $event)),
                class: "form-control form-control-lg form-control-solid",
                type: "number",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.rebateAccountUId,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schemaInfo.value.rebateAccountUId) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.rebate,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schemaInfo.value.rebate) = $event)),
                class: "form-control form-control-lg form-control-solid",
                type: "number",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.rebate,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schemaInfo.value.rebate) = $event)),
                    size: "large"
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("/100")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.alphaRebate,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schemaInfo.value.alphaRebate) = $event)),
                class: "form-control form-control-lg form-control-solid",
                type: "number",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.alphaRebate,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schemaInfo.value.alphaRebate) = $event)),
                    size: "large"
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("/100")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.proRebate,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schemaInfo.value.proRebate) = $event)),
                class: "form-control form-control-lg form-control-solid",
                type: "number",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.proRebate,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schemaInfo.value.proRebate) = $event)),
                    size: "large"
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("/100")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.excludeAccount,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((schemaInfo.value.excludeAccount) = $event)),
                class: "form-control form-control-lg form-control-solid",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.excludeAccount,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((schemaInfo.value.excludeAccount) = $event)),
                    size: "large",
                    rows: 5,
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.excludeSymbol,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((schemaInfo.value.excludeSymbol) = $event)),
                class: "form-control form-control-lg form-control-solid",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.excludeSymbol,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((schemaInfo.value.excludeSymbol) = $event)),
                    size: "large",
                    type: "textarea",
                    rows: 5
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_unref(Field), {
                modelValue: schemaInfo.value.note,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((schemaInfo.value.note) = $event)),
                class: "form-control form-control-lg form-control-solid",
                name: "symbolRule",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: schemaInfo.value.note,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((schemaInfo.value.note) = $event)),
                    size: "large",
                    rows: 5,
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", { class: "mt-13 d-flex flex-row-reverse" }, [
            _createElementVNode("button", {
              class: "btn btn-light btn-danger btn-lg me-3 mb-9",
              onClick: reset
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-light btn-success btn-lg me-3 mb-9",
              onClick: update
            }, " Add New ")
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})